import { ApolloError } from '@apollo/client';
import { useEffect, useState } from 'react';
import { useGetOrCreateConnectedAppObjectMutation } from '../../../__generated__/chirp/com/hubspot/applications/governance/rpc/ApplicationGovernanceAppAuthRpc.hooks';

interface GetOrCreateApprovableObjectIdProps {
  appId: number;
}

interface GetOrCreateApprovableObjectIdResponse {
  approvableObjectId?: number;
  error?: ApolloError;
  loading: boolean;
}

//Gets or creates object id needed to create and fetch product approval requests
export function useGetOrCreateApprovableObjectId({
  appId,
}: GetOrCreateApprovableObjectIdProps): GetOrCreateApprovableObjectIdResponse {
  const [getOrCreateConnectedAppObject, { loading, error }] =
    useGetOrCreateConnectedAppObjectMutation({
      variables: {
        appId,
      },
    });

  const [objectId, setObjectId] = useState<number | undefined>(undefined);

  useEffect(() => {
    getOrCreateConnectedAppObject()
      .then((result) => {
        setObjectId(result?.data?.result?.objectId);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [getOrCreateConnectedAppObject]);

  return {
    approvableObjectId: objectId,
    loading,
    error,
  };
}
